import { render, staticRenderFns } from "./DashLiveTicker.vue?vue&type=template&id=63673446&"
import script from "./DashLiveTicker.vue?vue&type=script&lang=js&"
export * from "./DashLiveTicker.vue?vue&type=script&lang=js&"
import style0 from "./DashLiveTicker.vue?vue&type=style&index=0&id=63673446&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports